import React from 'react';
import { MicroProfileForm } from '@/components/profile/MicroProfileForm';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export const CompleteProfile: React.FC = () => {
    const navigate = useNavigate();

    const handleComplete = () => {
        navigate('/micro-dashboard');
    };

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto w-full">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                    className="text-center mb-8"
                >
                    <h1 className="text-3xl font-bold text-slate-900 mb-2">Welcome! Let's finish setting up</h1>
                    <p className="text-lg text-slate-600">
                        Complete your profile to personalize your learning experience
                    </p>
                </motion.div>

                <MicroProfileForm mode="onboarding" onComplete={handleComplete} />
            </div>
        </div>
    );
};

export default CompleteProfile;
